import Event from "../event"
export const MAX_DURATION_DAYS = 365 * 10 // 10 years


export default function eventSetCalendarDuration(event:Event, value:number|null) {

    if (_.isNaN(value) || !String(value).trim() || value === null) value = 0;

    if (event.isSingleDayType) value = 1 // pathch

    if (value === 0) {
        // event.startDate(null)
        // hey event start always exists !
        return;
    }

    if (value > MAX_DURATION_DAYS) value = MAX_DURATION_DAYS

    const startDate = event.startDate ? event.startDate : momentDate()
    const endDate   = moment(startDate).add(value-1,'days')

    event.updateStartEnd(startDate, endDate)
}


